import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { useAppContext } from 'Context/ReactAppContext';
import { fetchBookableDates } from 'Store/calendar/calendar.action';
import { getDepartureDate, getDepartureCity } from 'Store/trip-criteria/tripCriteria.selector';
import { getPricesByDays, getAvailableDurations } from 'Store/calendar/calendar.selector';
import { timestampToApiDate } from 'Utils/date/apiDate';

const SUMMER = 'SUMMER';
const WINTER = 'WINTER';

export const useAvailableDurations = ({ initialTransport, productId }) => {
  const availableDurations = useSelector(getAvailableDurations);
  const prices = useSelector(getPricesByDays);
  const departureDate = useSelector(getDepartureDate);
  const departureCity = useSelector(getDepartureCity);
  const dispatch = useDispatch();
  const appContext = useAppContext();

  const apiDate = timestampToApiDate(departureDate);

  const isSiblingOpen = !!prices?.[apiDate]?.siblingOpen;

  const seasonProductId = isSiblingOpen
    ? (productId.includes(SUMMER) && productId.replace(SUMMER, WINTER)) ||
      productId.replace(WINTER, SUMMER)
    : productId;

  const transport = departureCity || initialTransport;

  useEffect(() => {
    if (!availableDurations && transport) {
      dispatch(
        fetchBookableDates(
          {
            departureCity: departureCity || initialTransport,
            productId: seasonProductId,
          },
          appContext,
        ),
      );
    }
  }, [seasonProductId, transport]);
  return availableDurations;
};
